import React from 'react';
import type { Platform } from '../types/expert';
type PlatformIconProps = {
  platform: Platform;
  className?: string;
};
const styles: Record<Platform, string> = {
  LinkedIn: 'bg-[#0A66C2] text-white',
  Instagram: 'bg-[#E1306C] text-white',
  X: 'bg-black text-white',
  YouTube: 'bg-[#FF0000] text-white'
};
export function PlatformIcon({
  platform,
  className = 'size-8'
}: PlatformIconProps) {
  return <span className={`inline-flex shrink-0 items-center justify-center rounded-md ${styles[platform]} ${className}`} aria-label={platform} role="img" data-id="element-538" data-mp="3srzx418340u8">
      {platform === 'LinkedIn' && <span className="text-[13px] font-bold leading-none tracking-tight" data-id="element-539" data-mp="5nbtg76v1ihm">in</span>}
      {platform === 'X' && <svg viewBox="0 0 24 24" className="size-[55%]" fill="currentColor" aria-hidden="true" data-id="element-540" data-mp="lmfaioccopb">
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" data-id="element-541" data-mp="1gzun174gctgw" />
        </svg>}
      {platform === 'Instagram' && <svg viewBox="0 0 24 24" className="size-[60%]" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true" data-id="element-542" data-mp="28q335cfg8tmk">
          <rect x="3" y="3" width="18" height="18" rx="5" data-id="element-543" data-mp="2doo278iyt79f" />
          <circle cx="12" cy="12" r="4" data-id="element-544" data-mp="2dnd1jhktgfmj" />
          <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" data-id="element-545" data-mp="2ioivfiq7q8xn" />
        </svg>}
      {platform === 'YouTube' && <svg viewBox="0 0 24 24" className="size-[55%]" fill="currentColor" aria-hidden="true" data-id="element-546" data-mp="1l2bs0c5nammv">
          <path d="M8 5v14l11-7z" data-id="element-547" data-mp="1q04zr9mljop9" />
        </svg>}
    </span>;
}